import React from "react";
import NotFoundImage from "../assets/img/NotFound.svg";
import { Link } from "react-router-dom";

const Style = {
  height: "320px",
  width: "320px",
  textAlign: "center",
};

const NotFoundPage = () => {
  return (
    <div style={Style}>
      <img src={NotFoundImage} />
      <p>Page Not Found!</p>
      <Link to="/">Go back</Link>
    </div>
  );
};

export default NotFoundPage;
